let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fzz7R")).then(() => parcelRequire('agOcn'));